import {
  FORM_PROPERTY_GROUP_BACKGROUNDS,
  FORM_PROPERTY_GROUP_BUTTON,
  FORM_PROPERTY_GROUP_HEADER,
  FORM_PROPERTY_GROUP_MESSAGING,
  FORM_PROPERTY_GROUP_METADATA
} from './formPropertyGroups'


export const CANVAS_MIXPANEL_EVENT_PROPERTIES = {
  'header': {
    location: 'Form Builder - Form Header',
    upgradeTextKey: 'Form Builder edit header logo',
  },
  'footer': {
    location: 'Form Builder - Form Footer',
    upgradeTextKey: 'Form Builder remove footer',
  },
  'footer-embed': {
    location: 'Form Builder - Embedded Form Footer',
    upgradeTextKey: 'Form Builder remove footer',
  },
  'submit-button': {
    location: 'Form Builder - Submit Button',
    upgradeTextKey: 'Form Builder style submit button',
  },
}

export const CONTEXT_MENU_MIXPANEL_EVENT_PROPERTIES = {
  'header': {
    location: 'Header Image Actions Menu',
    upgradeTextKey: 'Form Builder properties edit top logo',
  }
}

export const EMBEDDED_FORM_MIXPANEL_EVENT_PROPERTIES = {
  'style-embed': {
    location: 'Form Builder - Embedded Styling Panel',
    upgradeTextKey: 'Form Builder edit embedded styling',
  }
}

export const ENTRY_MANAGER_MIXPANEL_EVENT_PROPERTIES = {
  'create': {
    location: 'Entry Manager - Entry List',
    upgradeTextKey: 'Entry Manager create entry',
  },
  'download': {
    location: 'Entry Manager - Entry Details',
    upgradeTextKey: 'Entry Manager download entries',
  },
  'edit': {
    location: 'Entry Manager - Entry Details',
    upgradeTextKey: 'Entry Manager edit entry',
  },
  'print': {
    location: 'Entry Manager - Entry Details',
    upgradeTextKey: 'Entry Manager print entry',
  }
}

export const FORM_HEADER_MIXPANEL_EVENT_PROPERTIES = {
  'close': {
    location: 'Form Manager - Form Header Context Menu',
    upgradeTextKey: 'Form Builder close form',
  },
  'revert': {
    location: 'Form Manager - Form Header Context Menu',
    upgradeTextKey: 'Form Builder revert to last published',
  }
}

export const MODAL_MIXPANEL_EVENT_PROPERTIES = {
  'custom-url': {
    location: 'Form Manager - Share Modal',
    upgradeTextKey: 'Form Builder edit share url',
  },
  'hidden-fields': {
    location: 'Form Builder - Share Modal',
    upgradeTextKey: 'Form Builder include hidden fields',
  }
}

export const PROPERTY_PANEL_MIXPANEL_EVENT_PROPERTIES = {
  [FORM_PROPERTY_GROUP_MESSAGING]: {
    location: 'Form Builder - Property Panel',
    upgradeTextKey: 'Form Builder edit form messaging',
  },
  [FORM_PROPERTY_GROUP_METADATA]: {
    location: 'Form Builder - Property Panel',
    upgradeTextKey: 'Form Builder edit form metadata',
  }
}

export const STYLING_PANEL_MIXPANEL_EVENT_PROPERTIES = {
  [FORM_PROPERTY_GROUP_BACKGROUNDS]: {
    location: 'Form Builder - Styling Panel',
    upgradeTextKey: 'Form Builder edit form backgrounds',
  },
  [FORM_PROPERTY_GROUP_BUTTON]: {
    location: 'Form Builder - Styling Panel',
    upgradeTextKey: 'Form Builder edit submit button',
  },
  [FORM_PROPERTY_GROUP_HEADER]: {
    location: 'Form Builder - Styling Panel',
    upgradeTextKey: 'Form Builder edit header logo',
  },
}
